import styled from 'styled-components';

const SearchWrapper = styled.div`
  max-width: 500px;
  width: 100%;
  height: 50px;
  position: relative;
  display: grid;
  margin: 0 auto 20px auto;
`;
export default SearchWrapper;
